const drawerOptionsAdmin = {
    "INICIO": [
        {
            children: [],
            text: 'Mi muro',
            divider: true,
            id: "ini_mi_muro",
            value: "ini_mi_muro"
        },
        {
            children: [],
            text: 'Desconexión',
            divider: false,
            id: "ini_desconexion",
            value: "ini_desconexion"
        }
    ],
    "ACCIONES": [
        {
            children: [],
            text: 'Cierre diario',
            divider: false,
            id: "acc_cierre_diario",
            value: "acc_cierre_diario"
        },
        {
            children: [],
            text: 'Cierre semanal',
            divider: true,
            id: "acc_cierre_semanal",
            value: "acc_cierre_semanal"
        },
        {
            children: [],
            text: 'Mover máquinas',
            divider: true,
            id: "acc_mover_maquinas",
            value: "acc_mover_maquinas"
        },
        {
            children: [],
            text: 'Exportar contabilidad',
            divider: true,
            id: "acc_exportar_contabilidad",
            value: "acc_exportar_contabilidad"
        },
        // {
        //     children: [],
        //     text: 'Desbloquear cierre diario',
        //     divider: false,
        //     id: "acc_desbloquear_cierre_diario",
        //     value: "acc_desbloquear_cierre_diario"
        // },
        // {
        //     children: [],
        //     text: 'Desbloquear cierre semanal',
        //     divider: false,
        //     id: "acc_desbloquear_cierre_semanal",
        //     value: "acc_desbloquear_cierre_semanal"
        // },
        {
            children: [],
            text: 'Desbloquear contabilidad',
            divider: false,
            id: "acc_desbloquear_contabilidad",
            value: "acc_desbloquear_contabilidad"
        },
    ],
    "ENTRADA": [
        {
            children: [],
            text: 'Gastos',
            divider: false,
            id: "ent_gastos",
            value: "ent_gastos"
        },
        {
            children: [],
            text: 'MKT',
            divider: false,
            id: "ent_mkt",
            value: "ent_mkt"
        },
        {
            children: [],
            text: 'Lectura Máq. Cambio',
            divider: false,
            id: "ent_lectura_maq_cambio",
            value: "ent_lectura_maq_cambio"
        },
        {
            children: [],
            text: 'Partidas por tipo',
            divider: true,
            id: "ent_partidas_por_tipo",
            value: "ent_partidas_por_tipo"
        },
        {
            children: [],
            text: 'Lectura Máq. Arcade',
            divider: false,
            id: "ent_lectura_maq_arcade",
            value: "ent_lectura_maq_arcade"
        },
        {
            children: [],
            text: 'Ingresos Banco',
            divider: true,
            id: "ent_ingresos_banco",
            value: "ent_ingresos_banco"
        },
        {
            children: [],
            text: 'Presupuestos',
            divider: true,
            id: "ent_presupuestos",
            value: "ent_presupuestos"
        },
        {
            children: [],
            text: 'Alertas',
            divider: false,
            id: "ent_alertas",
            value: "ent_alertas"
        },
    ],
    "MAESTROS": [
        {
            children: [],
            text: 'Usuarios',
            divider: false,
            id: "mae_usuarios",
            value: "mae_usuarios"
        },
        {
            children: [],
            text: 'Empresa',
            divider: false,
            id: "mae_empresa",
            value: "mae_empresa"
        },
        {
            children: [],
            text: 'Centro',
            divider: false,
            id: "mae_centro",
            value: "mae_centro"
        },
        {
            children: [],
            text: 'Zona',
            divider: false,
            id: "mae_zona",
            value: "mae_zona"
        },
        {
            children: [],
            text: 'Máquina',
            divider: false,
            id: "mae_maquina",
            value: "mae_maquina"
        },
        {
            children: [
                {
                    children: [],
                    text: 'Tipo zona',
                    divider: true,
                    id: "mae_auxiliares_tipo_zona",
                    value: "mae_auxiliares_tipo_zona"
                },
                {
                    children: [],
                    text: 'Grupo partida',
                    divider: false,
                    id: "mae_auxiliares_grupo_partida",
                    value: "mae_auxiliares_grupo_partida"
                },
                {
                    children: [],
                    text: 'Tipo partida',
                    divider: true,
                    id: "mae_auxiliares_tipo_partida",
                    value: "mae_auxiliares_tipo_partida"
                },
                {
                    children: [],
                    text: 'Tipo máquina',
                    divider: false,
                    id: "mae_auxiliares_tipo_maquina",
                    value: "mae_auxiliares_tipo_maquina"
                },
                {
                    children: [],
                    text: 'Modelo máquina',
                    divider: true,
                    id: "mae_auxiliares_modelo_maquina",
                    value: "mae_auxiliares_modelo_maquina"
                },
                {
                    children: [],
                    text: 'Tipo producto',
                    divider: true,
                    id: "mae_auxiliares_tipo_articulo",
                    value: "mae_auxiliares_tipo_articulo"
                },
                {
                    children: [],
                    text: 'Tipo gasto',
                    divider: true,
                    id: "mae_auxiliares_tipo_gasto",
                    value: "mae_auxiliares_tipo_gasto"
                },
                {
                    children: [],
                    text: 'Perfiles de Usuario',
                    divider: false,
                    id: "mae_auxiliares_perfiles_usuario",
                    value: "mae_auxiliares_perfiles_usuario"
                },
            ],
            text: 'Auxiliares',
            divider: false,
            id: "mae_auxiliares",
            value: ""
        },
    ],
    "INFORMES": [
        {
            children: [],
            text: 'Resumen diario',
            divider: false,
            id: "inf_resumen_diario",
            value: "inf_resumen_diario"
        },
        {
            children: [],
            text: 'Resumen semanal',
            divider: false,
            id: "inf_resumen_semanal",
            value: "inf_resumen_semanal"
        },
        // {
        //     children: [],
        //     text: '(Internos)',
        //     divider: false,
        //     id: "inf_internos",
        //     value: "inf_internos"
        // },
        {
            children: [],
            text: 'Ventas',
            divider: false,
            id: "inf_ventas",
            value: "inf_ventas"
        },
        {
            children: [],
            text: 'Arcade',
            divider: false,
            id: "inf_arcade",
            value: "inf_arcade"
        },
        {
            children: [],
            text: 'Redemption',
            divider: true,
            id: "inf_redemption",
            value: "inf_redemption"
        },
        {
            children: [
                {
                    children: [],
                    text: 'Dias por año',
                    divider: true,
                    id: "inf_dias_anyo",
                    value: "inf_dias_anyo"
                },
                {
                    children: [],
                    text: 'Descuadres de caja',
                    divider: false,
                    id: "inf_descuadres_caja",
                    value: "inf_descuadres_caja"
                },
                // {
                //     children: [],
                //     text: 'Franjas horarias',
                //     divider: true,
                //     id: "inf_franjas_horarias",
                //     value: "inf_franjas_horarias"
                // }
            ],
            text: 'Otros',
            divider: false,
            id: "inf_otros",
            value: ""
        }
    ]
}

const drawerOptionsOther = {
    "INICIO": [
        {
            children: [],
            text: 'Mi muro',
            divider: true,
            id: "ini_mi_muro",
            value: "ini_mi_muro"
        },
        {
            children: [],
            text: 'Desconexión',
            divider: false,
            id: "ini_desconexion",
            value: "ini_desconexion"
        }
    ],
    "ACCIONES": [
        {
            children: [],
            text: 'Cierre diario',
            divider: false,
            id: "acc_cierre_diario",
            value: "acc_cierre_diario"
        },
        {
            children: [],
            text: 'Cierre semanal',
            divider: true,
            id: "acc_cierre_semanal",
            value: "acc_cierre_semanal"
        },
        {
            children: [],
            text: 'Mover máquinas',
            divider: true,
            id: "acc_mover_maquinas",
            value: "acc_mover_maquinas"
        },
        {
            children: [],
            text: 'Exportar contabilidad',
            divider: true,
            id: "acc_exportar_contabilidad",
            value: "acc_exportar_contabilidad"
        },
        {
            children: [],
            text: 'Desbloquear cierre diario',
            divider: false,
            id: "acc_desbloquear_cierre_diario",
            value: "acc_desbloquear_cierre_diario"
        },
        {
            children: [],
            text: 'Desbloquear cierre semanal',
            divider: false,
            id: "acc_desbloquear_cierre_semanal",
            value: "acc_desbloquear_cierre_semanal"
        },
        {
            children: [],
            text: 'Desbloquear contabilidad',
            divider: false,
            id: "acc_desbloquear_contabilidad",
            value: "acc_desbloquear_contabilidad"
        },
    ],
    "ENTRADA": [
        {
            children: [],
            text: 'Gastos',
            divider: false,
            id: "ent_gastos",
            value: "ent_gastos"
        },
        {
            children: [],
            text: 'MKT',
            divider: false,
            id: "ent_mkt",
            value: "ent_mkt"
        },
        {
            children: [],
            text: 'Lectura Máq. Cambio',
            divider: false,
            id: "ent_lectura_maq_cambio",
            value: "ent_lectura_maq_cambio"
        },
        {
            children: [],
            text: 'Partidas por tipo',
            divider: true,
            id: "ent_partidas_por_tipo",
            value: "ent_partidas_por_tipo"
        },
        {
            children: [],
            text: 'Lectura Máq. Arcade',
            divider: false,
            id: "ent_lectura_maq_arcade",
            value: "ent_lectura_maq_arcade"
        },
        {
            children: [],
            text: 'Ingresos Banco',
            divider: true,
            id: "ent_ingresos_banco",
            value: "ent_ingresos_banco"
        },
        {
            children: [],
            text: 'Presupuestos',
            divider: true,
            id: "ent_presupuestos",
            value: "ent_presupuestos"
        },
        {
            children: [],
            text: 'Alertas',
            divider: false,
            id: "ent_alertas",
            value: "ent_alertas"
        },
    ]
}


const drawerOptionsProfiles = {
    "INICIO": [
        {
            children: [],
            text: 'Noticias',
            divider: true,
            id: "ini_noticias",
            value: "ini_noticias",
            profiles: [0, 1, 2, 3, 4, 5, 6, 7, 8, 12, 14, 15, 16, 17, 18, 19, 20, 21, 23],
            kd: 0,
        },
        // {
        //     children: [],
        //     text: 'Desconexión',
        //     divider: false,
        //     id: "ini_desconexion",
        //     value: "ini_desconexion",
        //     profiles: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
        // }
    ],
    "ACCIONES": [
        {
            children: [],
            text: 'Cierre diario',
            divider: false,
            id: "acc_cierre_diario",
            value: "acc_cierre_diario",
            profiles: [0, 2, 3, 4, 5, 8, 12, 14, 15, 17, 18],
            kd: 0,
        },
        {
            children: [],
            text: 'Cierre semanal',
            divider: true,
            id: "acc_cierre_semanal",
            value: "acc_cierre_semanal",
            profiles: [0, 2, 3, 4, 5, 8, 14, 15, 17, 18],
            kd: 0,
        },
        {
            children: [],
            text: 'Inventario mensual',
            divider: false,
            id: "acc_inventario",
            value: "acc_inventario",
            profiles: [0, 2, 3, 4, 5, 8, 14, 15, 16, 17, 18],
            kd: 0,
        },
        {
            children: [],
            text: 'Mover máquinas',
            divider: true,
            id: "acc_mover_maquinas",
            value: "acc_mover_maquinas",
            profiles: [0, 2, 4, 5, 16, 17],
            kd: 0,
        },
        {
            children: [],
            text: 'Exportar contabilidad',
            divider: true,
            id: "acc_exportar_contabilidad",
            value: "acc_exportar_contabilidad",
            profiles: [0, 5, 16, 17],
            kd: 0,
        },
        // {
        //     children: [],
        //     text: 'Desbloquear cierre diario',
        //     divider: false,
        //     id: "acc_desbloquear_cierre_diario",
        //     value: "acc_desbloquear_cierre_diario"
        // },
        // {
        //     children: [],
        //     text: 'Desbloquear cierre semanal',
        //     divider: false,
        //     id: "acc_desbloquear_cierre_semanal",
        //     value: "acc_desbloquear_cierre_semanal"
        // },
        {
            children: [],
            text: 'Desbloquear contabilidad',
            divider: false,
            id: "acc_desbloquear_contabilidad",
            value: "acc_desbloquear_contabilidad",
            profiles: [0, 5, 16, 17],
            kd: 0,
        },
    ],
    "ENTRADA": [
        {
            children: [],
            text: 'Gastos',
            divider: false,
            id: "ent_gastos",
            value: "ent_gastos",
            //profiles: [0, 2, 3, 4, 5, 6, 8]
            profiles: [],
            kd: 0,
        },
        {
            children: [],
            text: 'MKT',
            divider: false,
            id: "ent_mkt",
            value: "ent_mkt",
            //profiles: [0, 2, 3, 4, 5, 6, 8]
            profiles: [],
            kd: 0,
        },
        {
            children: [],
            text: 'Lectura Máq. Cambio',
            divider: false,
            id: "ent_lectura_maq_cambio",
            value: "ent_lectura_maq_cambio",
            //profiles: [0, 2, 3, 4, 5, 6, 8]
            profiles: [],
            kd: 0,
        },
        {
            children: [],
            text: 'Partidas por tipo',
            divider: true,
            id: "ent_partidas_por_tipo",
            value: "ent_partidas_por_tipo",
            //profiles: [0, 2, 3, 4, 5, 6, 8]
            profiles: [],
            kd: 0,
        },
        {
            children: [],
            text: 'Lectura Máq. Arcade',
            divider: false,
            id: "ent_lectura_maq_arcade",
            value: "ent_lectura_maq_arcade",
            //profiles: [0, 2, 3, 4, 5, 6, 8]
            profiles: [],
            kd: 0,
        },
        {
            children: [],
            text: 'Ingresos Banco',
            divider: true,
            id: "ent_ingresos_banco",
            value: "ent_ingresos_banco",
            //profiles: [0, 2, 3, 4, 5, 6, 8]
            profiles: [],
            kd: 0,
        },
        // {
        //     children: [],
        //     text: 'Presupuestos',
        //     divider: true,
        //     id: "ent_presupuestos",
        //     value: "ent_presupuestos",
        //     profiles: [0, 2, 3, 4, 5, 8]
        // },
        {
            children: [],
            text: 'Recepción Albaranes',
            divider: false,
            id: "ent_albaran_pdte",
            value: "ent_albaran_pdte",
            profiles: [0, 2, 3, 4, 5, 6, 14, 15, 16, 17, 18, 22],
            kd: 1,
        },
        {
            children: [],
            text: 'Alertas',
            divider: false,
            id: "ent_alertas",
            value: "ent_alertas",
            profiles: [0, 2, 3, 4, 5, 7, 8, 12, 14, 15, 18],
            kd: 0,
        },
        {
            children: [],
            text: 'Hist. Albaranes',
            divider: false,
            id: "ent_albaran_hist",
            value: "ent_albaran_hist",
            profiles: [0, 2, 3, 4, 5, 6, 14, 15, 16, 17, 18, 22],
            kd: 1,
        },
        // {
        //     children: [],
        //     text: 'Pedidos / Albaranes',
        //     divider: false,
        //     id: "ent_pedido",
        //     value: "ent_pedido",
        //     profiles: [0, 2, 3, 4, 5, 6, 8]
        // },
    ],
    "MAESTROS": [
        {
            children: [],
            text: 'Usuarios',
            divider: false,
            id: "mae_usuarios",
            value: "mae_usuarios",
            profiles: [],
            kd: 0,
        },
        {
            children: [],
            text: 'Empresa',
            divider: false,
            id: "mae_empresa",
            value: "mae_empresa",
            profiles: [0, 2, 4, 5, 17, 18, 20],
            kd: 0,
        },
        {
            children: [],
            text: 'Centro',
            divider: false,
            id: "mae_centro",
            value: "mae_centro",
            profiles: [0, 2, 4, 5, 17, 18, 20],
            kd: 0,
        },
        {
            children: [],
            text: 'Zona',
            divider: false,
            id: "mae_zona",
            value: "mae_zona",
            profiles: [0, 2, 4, 5, 17, 18],
            kd: 1,
        },
        {
            children: [],
            text: 'Máquina',
            divider: false,
            id: "mae_maquina",
            value: "mae_maquina",
            profiles: [0, 2, 4, 5, 16, 17, 18],
            kd: 0,
        },
        {
            children: [],
            text: 'Presupuestos',
            divider: true,
            id: "ent_presupuestos",
            value: "ent_presupuestos",
            profiles: [0, 2, 3, 4, 5, 8, 17, 18, 20],
            kd: 0,
        },
        {
            children: [
                {
                    children: [],
                    text: 'Artículos',
                    divider: true,
                    id: "mae_redemption_articulo",
                    value: "mae_redemption_articulo",
                    profiles: [0, 2, 4, 5, 15, 16, 17, 18, 19, 20, 22],
                    kd: 1,
                },
                {
                    children: [],
                    text: 'Promocion',
                    divider: true,
                    id: "mae_redemption_promocion",
                    value: "mae_redemption_promocion",
                    profiles: [0, 2, 4, 5, 15, 16, 17, 18, 19, 20],
                    kd: 0,
                },
                // {
                //     children: [],
                //     text: 'Segmentación',
                //     divider: true,
                //     id: "mae_redemption_segmentacion",
                //     value: "mae_redemption_segmentacion",
                //     profiles: [0, 2, 4, 5, 15, 16, 17, 18, 19, 20]
                // },
                {
                    children: [],
                    text: 'Familia',
                    divider: true,
                    id: "mae_redemption_familia",
                    value: "mae_redemption_familia",
                    profiles: [0, 2, 4, 5, 15, 16, 17, 18, 19, 20],
                    kd: 1,
                },
                {
                    children: [],
                    text: 'Sub-familia',
                    divider: true,
                    id: "mae_redemption_sub_familia",
                    value: "mae_redemption_sub_familia",
                    profiles: [0, 2, 4, 5, 15, 16, 17, 18, 19, 20],
                    kd: 1,
                },
                {
                    children: [],
                    text: 'Ficha',
                    divider: true,
                    id: "mae_redemption_tipo_ficha",
                    value: "mae_redemption_tipo_ficha",
                    profiles: [0, 2, 4, 5, 15, 16, 17, 18, 19, 20],
                    kd: 0,
                },
                {
                    children: [],
                    text: 'Sub-ficha',
                    divider: true,
                    id: "mae_redemption_tipo_ficha_sub",
                    value: "mae_redemption_tipo_ficha_sub",
                    profiles: [0, 2, 4, 5, 15, 16, 17, 18, 19, 20],
                    kd: 0,
                },
                {
                    children: [],
                    text: 'Tipo Movimiento',
                    divider: true,
                    id: "mae_redemption_tipo_mov_redem",
                    value: "mae_redemption_tipo_mov_redem",
                    profiles: [0, 2, 4, 5, 15, 16, 17, 18, 19, 20],
                    kd: 0,
                },
                {
                    children: [],
                    text: 'Motivo',
                    divider: true,
                    id: "mae_redemption_motivo",
                    value: "mae_redemption_motivo",
                    profiles: [0, 2, 4, 5, 15, 16, 17, 18, 19, 20],
                    kd: 0,
                },
            ],
            text: 'Redemption',
            divider: false,
            id: "mae_redemption",
            value: "",
            profiles: [0, 2, 4, 5, 15, 16, 17, 18, 19, 20, 22],
            kd: 1,
        },
        {
            children: [
                {
                    children: [],
                    text: 'Tipo zona',
                    divider: true,
                    id: "mae_auxiliares_tipo_zona",
                    value: "mae_auxiliares_tipo_zona",
                    profiles: [0, 2, 4, 5, 17, 18],
                    kd: 1,
                },
                {
                    children: [],
                    text: 'Grupo partida',
                    divider: false,
                    id: "mae_auxiliares_grupo_partida",
                    value: "mae_auxiliares_grupo_partida",
                    profiles: [0, 2, 4, 5, 18],
                    kd: 0,
                },
                {
                    children: [],
                    text: 'Tipo partida',
                    divider: true,
                    id: "mae_auxiliares_tipo_partida",
                    value: "mae_auxiliares_tipo_partida",
                    profiles: [0, 2, 4, 5, 18],
                    kd: 0,
                },
                {
                    children: [],
                    text: 'Tipo máquina',
                    divider: false,
                    id: "mae_auxiliares_tipo_maquina",
                    value: "mae_auxiliares_tipo_maquina",
                    profiles: [0, 2, 4, 5, 16, 17],
                    kd: 0,
                },
                {
                    children: [],
                    text: 'Modelo máquina',
                    divider: true,
                    id: "mae_auxiliares_modelo_maquina",
                    value: "mae_auxiliares_modelo_maquina",
                    profiles: [0, 2, 4, 5, 16, 17],
                    kd: 0,
                },
                {
                    children: [],
                    text: 'Tipo producto',
                    divider: true,
                    id: "mae_auxiliares_tipo_articulo",
                    value: "mae_auxiliares_tipo_articulo",
                    profiles: [0, 2, 4, 5, 17, 18],
                    kd: 1,
                },
                {
                    children: [],
                    text: 'Tipo gasto',
                    divider: true,
                    id: "mae_auxiliares_tipo_gasto",
                    value: "mae_auxiliares_tipo_gasto",
                    profiles: [0, 2, 4, 5, 17, 18],
                    kd: 0,
                },
                {
                    children: [],
                    text: 'Tipos de zona de IVA',
                    divider: true,
                    id: "mae_auxiliares_tipo_zona_iva",
                    value: "mae_auxiliares_tipo_zona_iva",
                    profiles: [0, 2, 4, 5, 17],
                    kd: 0,
                },
                {
                    children: [],
                    text: 'Perfiles de Usuario',
                    divider: false,
                    id: "mae_auxiliares_perfiles_usuario",
                    value: "mae_auxiliares_perfiles_usuario",
                    profiles: [0, 2, 4, 5, 15, 17, 18, 20],
                    kd: 1,
                    //profiles: []
                },
            ],
            text: 'Auxiliares',
            divider: false,
            id: "mae_auxiliares",
            value: "",
            profiles: [0, 2, 4, 5, 15, 16, 17, 18, 20],
            kd: 1,
        },
    ],
    "INFORMES": [
        {
            children: [],
            text: 'Resumen diario',
            divider: false,
            id: "inf_resumen_diario",
            value: "inf_resumen_diario",
            profiles: [0, 2, 3, 4, 5, 8, 14, 15, 16, 17, 18, 19, 20, 21],
            kd: 0,
        },
        {
            children: [],
            text: 'Resumen semanal',
            divider: false,
            id: "inf_resumen_semanal",
            value: "inf_resumen_semanal",
            profiles: [0, 2, 3, 4, 5, 8, 14, 15, 16, 17, 18, 19, 20, 21],
            kd: 0,
        },
        {
            children: [],
            text: 'Resumen ventas',
            divider: false,
            id: "inf_resumen_ventas",
            value: "inf_resumen_ventas",
            profiles: [0, 2, 3, 4, 5, 8, 14, 15, 17, 18, 19, 20, 21],
            kd: 0,
        },
        {
            children: [],
            text: 'Ventas ...',
            divider: false,
            id: "inf_ventas",
            value: "inf_ventas",
            profiles: [0, 1, 2, 3, 4, 5, 8, 10, 12, 14, 15, 16, 17, 18, 19, 20, 21],
            kd: 0,
        },
        {
            children: [],
            text: 'Arcade ...',
            divider: false,
            id: "inf_arcade",
            value: "inf_arcade",
            profiles: [0, 1, 2, 3, 4, 5, 8, 10, 12, 14, 15, 16, 17, 18, 19, 20, 21],
            kd: 0,
        },
        {
            children: [],
            text: 'Redemption ...',
            divider: true,
            id: "inf_redemption",
            value: "inf_redemption",
            profiles: [0, 1, 2, 3, 4, 5, 8, 10, 12, 14, 15, 16, 17, 18, 19, 20, 21],
            kd: 0,
        },
        {
            children: [
                {
                    children: [],
                    text: 'Dias por año',
                    divider: true,
                    id: "inf_dias_anyo",
                    value: "inf_dias_anyo",
                    profiles: [0, 1, 2, 3, 4, 5, 8, 10, 14, 15, 16, 17, 18, 19, 20,21],
                    kd: 0,
                },
                {
                    children: [],
                    text: 'Descuadres de caja',
                    divider: false,
                    id: "inf_descuadres_caja",
                    value: "inf_descuadres_caja",
                    profiles: [0, 1, 2, 3, 4, 5, 8, 10, 14, 15, 16, 17, 18, 19, 20, 21],
                    kd: 0,
                },
                // {
                //     children: [],
                //     text: 'Franjas horarias',
                //     divider: true,
                //     id: "inf_franjas_horarias",
                //     value: "inf_franjas_horarias"
                // }
            ],
            text: 'Otros',
            divider: false,
            id: "inf_otros",
            value: "",
            profiles: [0, 1, 2, 3, 4, 5, 8, 10, 14, 15, 16, 17, 18, 19, 20, 21],
            kd: 0,
        }
    ],
}



export const drawerOptions = {
    "Admin": drawerOptionsAdmin,
    "Other": drawerOptionsOther
}

export function getDrawerOptions(iProfile, iUser, kd) {

    let optionsInicio = drawerOptionsProfiles["INICIO"].slice();
    let optionsEntrada = drawerOptionsProfiles["ENTRADA"].slice();
    let optionsInformes = drawerOptionsProfiles["INFORMES"].slice();

    if (iUser === '795' || iUser === '1036') {
        optionsInicio.push(
            {
                children: [
                    {
                        children: [],
                        text: 'Ventas',
                        divider: false,
                        id: "ini_ventas",
                        value: "ini_ventas",
                        profiles: [0, 2, 4, 5],
                        kd: 0,
                    },
                    {
                        children: [],
                        text: 'Arcades',
                        divider: false,
                        id: "ini_arcades",
                        value: "ini_arcades",
                        profiles: [0, 2, 4, 5],
                        kd: 0,
                    },
                    {
                        children: [],
                        text: 'Cierres',
                        divider: true,
                        id: "ini_cierres",
                        value: "ini_cierres",
                        profiles: [0, 2, 4, 5],
                        kd: 0,
                    }
                ],
                text: 'Mi Muro',
                divider: false,
                id: "ini_mi_muro",
                value: "ini_mi_muro",
                profiles: [0, 2, 4, 5],
                kd: 0,
            },
            {
                children: [],
                text: 'Test',
                divider: true,
                id: "mae_redemption_segmentacion",
                value: "mae_redemption_segmentacion",
                profiles: [0, 1, 2, 3, 4, 5, 8, 10],
                kd: 0,
            }
        );
    }
    else {
        optionsInicio.push(
            {
                children: [],
                text: 'Mi Muro',
                divider: false,
                id: "ini_mi_muro",
                value: "ini_mi_muro",
                profiles: [0, 2, 4, 5, 14, 15, 18, 19, 20, 21],
                kd: 1,
            }
        );
    }

    if (kd !== undefined) {
        optionsInicio.push({
            children: [],
            text: 'Importar',
            divider: false,
            id: "ini_importar_kd",
            value: "ini_importar_kd",
            profiles: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 14, 15, 16, 17, 18, 19, 20, 21],
            kd: 1,
        });

        optionsInicio.push(
            {
                children: [
                    {
                        children: [],
                        text: 'General',
                        divider: true,
                        id: "ini_mi_muro_kd",
                        value: "ini_mi_muro_kd",
                        profiles: [0, 2, 4, 5],
                        kd: 1,
                    },
                    {
                        children: [],
                        text: 'Cierres',
                        divider: true,
                        id: "ini_cierres_kd",
                        value: "ini_cierres_kd",
                        profiles: [0, 2, 4, 5],
                        kd: 1,
                    },
                    {
                        children: [],
                        text: 'Ventas',
                        divider: true,
                        id: "ini_ventas_kd",
                        value: "ini_ventas_kd",
                        profiles: [0, 2, 4, 5],
                        kd: 1,
                    }
                ],
                text: 'Dashboard',
                divider: false,
                id: "dashboard",
                value: "",
                profiles: [0, 2, 4, 5],
                kd: 1,
            },
            {
                children: [],
                text: 'Test',
                divider: true,
                id: "mae_redemption_segmentacion",
                value: "mae_redemption_segmentacion",
                profiles: [0, 1, 2, 3, 4, 5, 8, 10],
                kd: 0,
            }
        );

        optionsEntrada.push(
            {
                children: [],
                text: 'Inventario mensual',
                divider: false,
                id: "acc_inventario",
                value: "acc_inventario",
                profiles: [0, 2, 3, 4, 5, 8, 14, 15, 16, 17, 18],
                kd: 1,
            }
        );

        optionsInformes.push(
            {
                children: [],
                text: 'Informes ...',
                divider: true,
                id: "inf_redemption",
                value: "inf_redemption",
                profiles: [0, 1, 2, 3, 4, 5, 8, 10, 12, 14, 15, 16, 17, 18, 19, 20, 21],
                kd: 1,
            },
        );

    }

    optionsInicio.push({
        children: [],
        text: 'Desconexión',
        divider: false,
        id: "ini_desconexion",
        value: "ini_desconexion",
        profiles: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 14, 15, 16, 17, 18, 19, 20, 21],
        kd: 1,
    });

    const filteredOptions = {};
    filteredOptions["INICIO"] = optionsInicio.filter(c => c.profiles.includes(iProfile) && (kd === undefined || c.kd === 1)).map(item => filterOptions(item, iProfile, kd));
    filteredOptions["ACCIONES"] = drawerOptionsProfiles["ACCIONES"].filter(c => c.profiles.includes(iProfile) && (kd === undefined || c.kd === 1)).map(item => filterOptions(item, iProfile, kd));
    filteredOptions["ENTRADA"] = optionsEntrada.filter(c => c.profiles.includes(iProfile) && (kd === undefined || c.kd === 1)).map(item => filterOptions(item, iProfile, kd));
    filteredOptions["INFORMES"] = optionsInformes.filter(c => c.profiles.includes(iProfile) && (kd === undefined || c.kd === 1)).map(item => filterOptions(item, iProfile, kd));
    filteredOptions["MAESTROS"] = drawerOptionsProfiles["MAESTROS"].filter(c => c.profiles.includes(iProfile) && (kd === undefined || c.kd === 1)).map(item => filterOptions(item, iProfile, kd));

    const options = {};
    if (filteredOptions["INICIO"].length > 0) options["INICIO"] = filteredOptions["INICIO"];
    if (filteredOptions["ACCIONES"].length > 0) options["ACCIONES"] = filteredOptions["ACCIONES"];
    if (filteredOptions["ENTRADA"].length > 0) options["ENTRADA"] = filteredOptions["ENTRADA"];
    if (filteredOptions["INFORMES"].length > 0) options["INFORMES"] = filteredOptions["INFORMES"];
    if (filteredOptions["MAESTROS"].length > 0) options["MAESTROS"] = filteredOptions["MAESTROS"];

    return options;

}

function filterOptions(node, iProfile, kd) {

    return { ...node, children: node.children.filter(c => c.profiles.includes(iProfile) && (kd === undefined || c.kd === 1)).map((item) => filterOptions(item, iProfile)) };

}
